<template>
  <b-modal
    no-fade
    :visible="true"
    :title="$t('label.select_contact')"
    hide-footer
    @hide="onHide"

  >
    <div class="row mb-3">
      <div class="col-12">
        <div class="el-input el-input--prefix">
          <input
            type="text"
            v-model.lazy="model.search" v-debounce="350"
            autocomplete="off"
            placeholder="Type something"
            class="el-input__inner"
          >
            <span class="el-input__prefix">
              <i class="el-input__icon el-icon-search"></i>
            </span>
        </div>
      </div>
    </div>

    <el-scrollbar ref="scrollBar">
      <b-list-group flush
                    style="min-height: 500px; max-height: 500px">
        <b-list-group-item
          class="py-1 px-1"
          v-for="contact in filteredContacts"
          href="#"
          @click.prevent="onContactSelected(contact)"
          :key="contact.id">
          <div class="row" style="margin-right: 0px">
            <div  style="padding-left:15px; max-width: 60px; width: 60px">
              <div class="flag-icon" style="height: 32px; width: 32px;" :class="'flag-icon-'+contact.country.toLowerCase()"></div>
            </div>
            <div class="flex-grow-1">
              <p class="my-0">{{contact.first_name}}</p>
              <small class="my-0">{{contact.phone}}</small>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </el-scrollbar>

  </b-modal>
</template>



<script>
  import debounce from 'v-debounce';
  export default {
    $_veeValidate: {
      validator: 'new'
    },
    components:{

    },
    directives:{
      debounce
    },

    data() {
      return {
        loading: false,
        visible: false,
        model: {
          search: null,
        },
        contacts: [],
      }
    },
    computed: {
      filteredContacts(){
        return this.contacts.filter(c=>{
          if(!this.model.search) return true;
          const name = (c.first_name || "").toLowerCase();
         return name.startsWith(this.model.search);
        })
      }
    },
    watch: {
      'filteredContacts': function(val){
        this.$nextTick(this.$refs.scrollBar.update);
      }
    },
    methods: {
      onHide (evt) {
        evt.preventDefault();
        this.$emit('close', false);
      },
      fetchContacts() {
        return this.$store.dispatch('getContacts', {});
      },

      init() {
        this.loading = true;
        this.fetchContacts()
          .then(contacts => {
            this.loading = false;
            this.contacts = contacts;
          })
      },

      onContactSelected(data) {
        this.$emit('contactSelected', data);
      },
    },
    created() {
      this.init();
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/common/ContactPickerModal.vue